/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2017, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  Input,
  Button,
  SvgIcon
} from '../'

export const Search = (props) => (
  <div className={props.className}>
    {props.label &&
      <div>{props.label}</div>
    }
    <div className="slds-grid">
      <div className='slds-p-right_xx-small'>
        <Input
          value={props.value}
          placeholder={props.placeholder}
          onChange={props.onChange}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              props.onClick()
            }
          }}
          clearIcon={true}
          onClear={props.onClear}
        />
      </div>
      <div>
        <Button
          title="Search"
          type={props.buttonType}
          onClick={props.onClick}
          style={{ paddingLeft: '0.6em', paddingRight: '0.6em' }}>
          <SvgIcon
            variant="utility"
            symbol="search"
            colour="inverse"
            buttonIcon={true}
          />
        </Button>
      </div>
    </div>
  </div>
)

Search.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func,
  buttonType: PropTypes.oneOf(["reset", "brand", "destructive", "inverse"]),
  className: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/components/search/index.js